// extracted by mini-css-extract-plugin
module.exports = {"tbTagCategoriesMulti":"TagCategories_tbTagCategoriesMulti__f_1vb","tbTagCategoriesSingle":"TagCategories_tbTagCategoriesSingle__ttLT6"};